import React, { useState, useEffect } from 'react';
import MaskedInput from 'antd-mask-input';

import { PhoneOutlined,} from '@mui/icons-material/';
import { Grid} from '@material-ui/core';

import { Form, Input, Spin, Radio, Select as SelectAntd} from 'antd';
import AgradecimentoMirim from './Agradecimento';
import Button2 from '@components/Shared/Buttons/Button';

import './styles.css';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import ButtonComponent from '@components/Shared/Buttons/Button';
import { TitlePage} from '@styles/styles.global';
//import '@styles/AntStyles.css';
import { addDays } from 'date-fns';
import {
  ArrowRightOutlined,
} from '@ant-design/icons';
import UFs from '@components/Shared/BuscaEstados/UF2.json';

import Service, {
  IRequestCreatePessoa, IRequestCreatePessoaCrianca, IRequestCreatePessoaTeste,
} from './services';
import { MaskCPF } from '@utils/Masks';
import SearchCEPCorreios from '@utils/SearchCEPCorreios';
import useDebounce from '@hooks/useDebounce';


const DATA = addDays(new Date(), 0).toISOString().split('T')[0];

interface IEstado {
  id: string | number;
  label: string;
}

const CadastroMirim: React.FC = () => {

  const [formEtapa1] = Form.useForm();
  const [formEtapa2] = Form.useForm();
  const [loadingCreatePessoaResponsavel, setLoadingCreatePessoaResponsavel] = useState(false);
  const [loadingCreatePessoaCrianca, setLoadingCreatePessoaCrianca] = useState(false);
  const [loadingCEP, setLoadingCEP] = useState(false);
  const [uf, setUF] = useState<any>();
  const [loadingCEP2, setLoadingCEP2] = useState(false);
  const [suggestionsEstado, setSuggestionsEstado] = useState<IEstado[]>(
    UFs.UF,
  );

  const [etapa, setEtapa] = useState(1);
  const [dadosEtapa1, setDadosEtapa1] = useState<any>({});


  const [openModalAgradecimentoMirim, setOpenModalAgradecimentoMirim] =
  useState(false);

  function handleInput(e: any) {
    var ss = e.target.selectionStart;
    var se = e.target.selectionEnd;
    e.target.value = e.target.value.toUpperCase();
    e.target.selectionStart = ss;
    e.target.selectionEnd = se;
  };

  const validarData = (data: string) => {
    const [dia, mes, ano] = data.split('/').map(Number);
    const dataValida = new Date(ano, mes - 1, dia);

    return (
      dataValida.getFullYear() === ano &&
      dataValida.getMonth() === mes - 1 &&
      dataValida.getDate() === dia
    );
  };



  async function onSubmitCrianca(values: any, idResponsavel: number) {
    setLoadingCreatePessoaCrianca(true);
    //setLoading(true);

    console.log('Valores criança:', values);
    console.log('ID responsável:', idResponsavel);

    const services = new Service();

    const createPessoaCrianca: IRequestCreatePessoaCrianca = {
      nome: values.nome_crianca,
      cpfcnpj: values.cpfcnpj_crianca,
      data_nascimento: values.data_nascimento_crianca,
      entidade: 'pai_eterno',
      id_pessoa_responsavel: idResponsavel
    };

    console.log('Dados enviados para criança:', createPessoaCrianca);

    const { error, response } =
      await services.CreatePessoaCrianca(createPessoaCrianca);

    if (!error) {
      console.log('Criança criada:', response);
    } else {
      window.alert(
        'Erro - Sem contato com a base de dados. Por favor tente novamente ou entre em contato com a central de relacionamento!'
      );
    }

    setLoadingCreatePessoaCrianca(false);
  }





  async function onSubmitResponsavel(values: any) {
    setLoadingCreatePessoaResponsavel(true);
    //setLoading(true);

    console.log(values);

    const services = new Service();

    function limparValor(valor: string): string {
      return valor.replace(/[^\d]+/g, '');
    }

    const cepLimpo = limparValor(values.cep);

    const createPessoaResponsavel: IRequestCreatePessoa = {
      pessoa: {
        nome: values.nome,
        cpfcnpj: values.cpfcnpj,
        email: values.email,
        telefone: values.telefone,
        data_nascimento: values.data_nascimento,
        indicador: values.indicador,
        leu_comunicado_privacidade: true,
        concede_compartilhamento_dados: false,
      },
      endereco: {
        descricao: values.descricao,
        numero: values.numero,
        complemento: values.complemento,
        bairro: values.bairro,
        cidade: values.cidade,
        cep: cepLimpo,
        uf: values.uf,
      },
      entidade: {
        nome: 'pai_eterno'
      },
      campanha: {
        descricao: 'teste',
      }
    };

    console.log('Criando responsável...');

    const { error, response } =
      await services.CreatePessoa(createPessoaResponsavel);

    if (!error) {
      console.log('Resposta responsável:', response.id);
      setLoadingCreatePessoaResponsavel(false);

      // Se response for o ID diretamente:
      return response.id;


    } else {
      window.alert(
        'Erro - Sem contato com a base de dados. Por favor tente novamente ou entre em contato com a central de relacionamento!'
      );
      setLoadingCreatePessoaResponsavel(false);

      return null;

    }


  }

  const onSubmitFinal = async (valuesEtapa2: any) => {
    try {
      console.log('DADOS ETAPA 1 SALVOS:', dadosEtapa1);
      console.log('DADOS ETAPA 2:', valuesEtapa2);

      const values = {
        ...dadosEtapa1,
        ...valuesEtapa2,
      };

      console.log(
        'DADOS COMPLETOS:',
        JSON.stringify(values, null, 2)
      );

      // 1. Cria responsável
      const idResponsavel = await onSubmitResponsavel(values);

      if (!idResponsavel) {
        console.error('Não foi retornado ID do responsável');
        return;
      }

      console.log('ID RESPONSÁVEL CRIADO:', idResponsavel);

      // 2. Cria criança
      await onSubmitCrianca(values, idResponsavel);

      setOpenModalAgradecimentoMirim(true)

    } catch (error) {
      console.error('ERRO NO CADASTRO:', error);

    } finally {
      setLoadingCreatePessoaResponsavel(false);
      setLoadingCreatePessoaCrianca(false);
    }
  };

  const searchCEPDebounce = async (value: string) => {
    const searchCEPCorreios = new SearchCEPCorreios();

    setLoadingCEP(true);
    const { error, response } = await searchCEPCorreios.SearchCEP(value);
    setLoadingCEP2(true);
    setLoadingCEP(false);
    if (!error && response) {
      setUF(response.uf);
      formEtapa2.setFieldsValue({
        descricao: response.logradouro,
        bairro: response.bairro,
        uf: response.uf,
        cidade: response.localidade,
      });
    }
  };

  const debounceCEP = useDebounce(searchCEPDebounce, 800);


  const handleContinuar = async () => {
    try {
      const values = await formEtapa1.validateFields();

      console.log('DADOS ETAPA 1:', values);

      // Guarda explicitamente os dados da primeira etapa
      setDadosEtapa1(values);

      setEtapa(2);

    } catch (error) {
      console.log('Existem campos inválidos na etapa 1:', error);
    }
  };

  return (
    <>

    {/* MODAL */}
    {openModalAgradecimentoMirim && (
      <AgradecimentoMirim
        onClose={() => setOpenModalAgradecimentoMirim(false)}
      />
    )}
      <Grid container>
        <div
          style={{
            position: 'relative',
            width: '100%',
          }}
        >

          {/* ================== CABEÇALHO ==================== */}

          <Grid container>
            <Grid item lg={12} sm={12} xs={12}>
              <img
                src={'https://crm-clickdobem.s3.sa-east-1.amazonaws.com/AFIPE/logo_cabecalho.png'}
                alt="Cabeçalho"
                style={{
                  width: '100%',
                  height: 'auto',
                  display: 'block',
                }}
              />
            </Grid>
          </Grid>

          {/* ================== FORMULÁRIO ==================== */}

          <Grid container item lg={12} sm={12} xs={12}
            justify="center"
            alignItems="center"
            style={{
              marginTop: '-40px',
              position: 'relative',
              zIndex: 10,
            }}
          >
            <div
              style={{
                width: 'min(80%, 1080px)',
                maxWidth: '1070px',
                margin: '0 auto',
                backgroundColor: '#fff',
                border: '1px solid #ddd',
                borderRadius: '15px',
                padding: '30px',
                boxShadow: '0 4px 15px rgba(0,0,0,0.15)',
                boxSizing: 'border-box',
              }}
            >
              <Grid container justify="center"
                style={{
                  width: '100%',
                  margin: 0,
                }}
              >
                <Grid
                  item
                  lg={12}
                  sm={12}
                  xs={12}
                  style={{
                    width: '100%',
                    padding: 0,
                  }}
                >
                  {etapa === 1 && (
  <Form
    form={formEtapa1}
    size="middle"
    layout="vertical"
    scrollToFirstError
    onFinish={handleContinuar}
    labelAlign="left"
    requiredMark={false}
    style={{
      width: '100%',
    }}
    initialValues={{
      nome_crianca: '',
      cpfcnpj_crianca: '',
      data_nascimento_crianca: '',
      nome: '',
      cpfcnpj: '',
      data_nascimento: '',
      telefone: '',
      email: '',
    }}
  >

    {/* ================= DADOS CRIANÇA ================= */}

    <Grid container>

      <Grid container className="section-title-grid">
        <div className="section-title-wrapper-crianca">
          <h2 className="section-title-text-crianca">
            <span className="section-star-crianca">
              <svg
                viewBox="0 0 100 100"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M50 6 C52 6, 54 8, 55 11 L64 34 L88 36 C92 36, 95 39, 96 42 C97 45, 96 48, 93 50 L75 65 L81 87 C82 91, 81 94, 78 96 C75 98, 72 97, 69 95 L50 82 L31 95 C28 97, 25 98, 22 96 C19 94, 18 91, 19 87 L25 65 L7 50 C4 48, 3 45, 4 42 C5 39, 8 36, 12 36 L36 34 L45 11 C46 8, 48 6, 50 6 Z"
                  fill="currentColor"
                />
              </svg>
            </span>

            Dados do doador mirim
          </h2>

          <div className="section-line-crianca" />

          <span className="section-heart-crianca">
            <svg
              viewBox="0 0 100 90"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M50 82 C46 78, 12 57, 8 34 C5 18, 15 7, 29 5 C39 4, 47 9, 50 18 C53 9, 61 4, 71 5 C85 7, 95 18, 92 34 C88 57, 54 78, 50 82 Z"
                fill="currentColor"
              />
            </svg>
          </span>
        </div>
      </Grid>

      <Grid container justify="center" className="responsavel-form-grid">

        <Grid item lg={12} sm={12} xs={12} className="campo-grid">

          <Form.Item
            label={
              <span>
                Nome completo criança{' '}
                <span style={{ color: 'red' }}>*</span>
              </span>
            }
            name="nome_crianca"
            rules={[
              {
                required: true,
                message: '*Campo obrigatório',
              },
              {
                min: 3,
                message: 'Mínimo de 3 letras',
              },
              {
                pattern: /^[A-Za-záàâãéèêíïóôõöúçñÁÀ ÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/,
                message: 'Somente letras',
              },
            ]}
          >
            <Input
              onInput={handleInput}
              placeholder="Digite o nome da criança"
            />
          </Form.Item>

        </Grid>

      </Grid>

      <Grid container justify="center">

        <Grid item lg={6} sm={6} xs={12} className="campo-grid">

          <Form.Item
            label={
              <span>
                Data de nascimento{' '}
                <span style={{ color: 'red' }}>*</span>
              </span>
            }
            name="data_nascimento_crianca"
            rules={[
              {
                required: true,
                message: 'Campo obrigatório',
              },
              {
                validator: (_, value) => {
                  if (!value || validarData(value)) {
                    return Promise.resolve();
                  }

                  return Promise.reject(
                    new Error('Digite uma data válida!')
                  );
                },
              },
            ]}
          >
            <MaskedInput
              mask="11/11/1111"
              max={DATA}
              placeholder="dd/mm/aaaa"
            />
          </Form.Item>

        </Grid>

        <Grid item lg={6} sm={6} xs={12} className="campo-grid">

          <Form.Item
            label={
              <span>
                CPF (opcional)
              </span>
            }
            name="cpfcnpj_crianca"
            rules={[
              {
                required: false,
              },
              {
                len: 14,
                message: 'Digite um CPF completo',
              },
              {
                validator: (_, value) => {
                  if (!value) {
                    return Promise.resolve();
                  }

                  const cpf = value.replace(/\D/g, '');

                  if (cpf.length !== 11) {
                    return Promise.reject(
                      new Error('Digite um CPF válido')
                    );
                  }

                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input
              placeholder="000.000.000-00"
              maxLength={14}
              onChange={(e: any) => {
                const value = MaskCPF(e.target.value);

                // CORREÇÃO:
                // agora altera o CPF DA CRIANÇA
                formEtapa1.setFieldsValue({
                  cpfcnpj_crianca: value,
                });
              }}
            />
          </Form.Item>

        </Grid>

      </Grid>

    </Grid>


    {/* ================= DADOS RESPONSÁVEL ================= */}

    <Grid container style={{ paddingTop: 40 }}>

      <Grid container className="section-title-grid">

        <div className="section-title-wrapper-responsavel">

          <h2 className="section-title-text-responsavel">

            <span className="section-star-responsavel">

              <svg
                viewBox="0 0 100 100"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M50 6 C52 6, 54 8, 55 11 L64 34 L88 36 C92 36, 95 39, 96 42 C97 45, 96 48, 93 50 L75 65 L81 87 C82 91, 81 94, 78 96 C75 98, 72 97, 69 95 L50 82 L31 95 C28 97, 25 98, 22 96 C19 94, 18 91, 19 87 L25 65 L7 50 C4 48, 3 45, 4 42 C5 39, 8 36, 12 36 L36 34 L45 11 C46 8, 48 6, 50 6 Z"
                  fill="currentColor"
                />
              </svg>

            </span>

            Dados do responsável

          </h2>

          <div className="section-line-responsavel" />

          <span className="section-heart-responsavel">

            <svg
              viewBox="0 0 100 90"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M50 82 C46 78, 12 57, 8 34 C5 18, 15 7, 29 5 C39 4, 47 9, 50 18 C53 9, 61 4, 71 5 C85 7, 95 18, 92 34 C88 57, 54 78, 50 82 Z"
                fill="currentColor"
              />
            </svg>

          </span>

        </div>

      </Grid>


      <Grid container justify="center">

        <Grid item lg={12} sm={12} xs={12} className="campo-grid">

          <Form.Item
            label={
              <span>
                Nome completo responsável{' '}
                <span style={{ color: 'red' }}>*</span>
              </span>
            }
            name="nome"
            rules={[
              {
                required: true,
                message: '*Campo obrigatório',
              },
              {
                min: 3,
                message: 'Mínimo de 3 letras',
              },
              {
                pattern: /^[A-Za-záàâãéèêíïóôõöúçñÁÀ ÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/,
                message: 'Somente letras',
              },
            ]}
          >
            <Input
              onInput={handleInput}
              placeholder="Digite o nome do responsável"
            />
          </Form.Item>

        </Grid>

      </Grid>


      <Grid container justify="center">

        <Grid
          item
          lg={12}
          sm={12}
          xs={12}
          style={{
            paddingRight: 20,
            paddingLeft: 20,
          }}
        >

          <Form.Item
            label={
              <span>
                CPF <span style={{ color: 'red' }}>*</span>
              </span>
            }
            name="cpfcnpj"
            rules={[
              {
                required: true,
                message: '*Campo obrigatório',
              },
              {
                len: 14,
                message: 'Digite um CPF completo',
              },
              {
                validator: (_, value) => {
                  if (!value) {
                    return Promise.resolve();
                  }

                  const cpf = value.replace(/\D/g, '');

                  if (cpf.length !== 11) {
                    return Promise.reject(
                      new Error('Digite um CPF válido')
                    );
                  }

                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input
              placeholder="000.000.000-00"
              maxLength={14}
              onChange={(e: any) => {
                const value = MaskCPF(e.target.value);

                formEtapa1.setFieldsValue({
                  cpfcnpj: value,
                });
              }}
            />
          </Form.Item>

        </Grid>

      </Grid>


      <Grid container justify="center">

        <Grid item lg={6} sm={6} xs={12} className="campo-grid">

          <Form.Item
            label={
              <span>
                Data de nascimento{' '}
                <span style={{ color: 'red' }}>*</span>
              </span>
            }
            name="data_nascimento"
            rules={[
              {
                required: true,
                message: 'Campo obrigatório',
              },
              {
                validator: (_, value) => {
                  if (!value || validarData(value)) {
                    return Promise.resolve();
                  }

                  return Promise.reject(
                    new Error('Digite uma data válida!')
                  );
                },
              },
            ]}
          >
            <MaskedInput
              mask="11/11/1111"
              max={DATA}
              placeholder="dd/mm/aaaa"
            />
          </Form.Item>

        </Grid>


        <Grid item lg={6} sm={6} xs={12} className="campo-grid">

          <Form.Item
            label={
              <span>
                Celular <span style={{ color: 'red' }}>*</span>
              </span>
            }
            name="telefone"
            rules={[
              {
                required: true,
                message: '*Campo obrigatório',
              },
            ]}
          >
            <MaskedInput
              mask="(11) 11111-1111"
              placeholder="(00) 00000-0000"
            />
          </Form.Item>

        </Grid>

      </Grid>


      <Grid container justify="center">

        <Grid item lg={12} sm={12} xs={12} className="campo-grid">

          <Form.Item
            label={
              <span>
                E-mail <span style={{ color: 'red' }}>*</span>
              </span>
            }
            name="email"
            rules={[
              {
                required: true,
                message: '*Campo obrigatório',
              },
              {
                pattern:
                  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
                message: 'Digite um e-mail válido!',
              },
            ]}
          >
            <Input
              placeholder="exemplo@email.com"
            />
          </Form.Item>

        </Grid>

      </Grid>

    </Grid>


    {/* ================= BOTÃO CONTINUAR ================= */}

    <Grid
      container
      item
      lg={12}
      sm={12}
      xs={12}
      justify="center"
      style={{ marginTop: 49 }}
    >
      <ButtonComponent
        type="submit"
        color="secondary"
        style={{
          width: '220px',
          maxWidth: '100%',
          minHeight: '45px',
          height: 'auto',
          minWidth: 0,
          borderRadius: '22px',
          background:
            'linear-gradient(90deg, #2196D3, #2FA9E8)',
          border: 'none',
          color: '#fff',
          fontSize: '18px',
          fontWeight: 600,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '10px',
          padding: '10px 20px',
          boxShadow: 'none',
          boxSizing: 'border-box',
        }}
      >
        <span>Continuar</span>

        <ArrowRightOutlined
          style={{
            fontSize: '24px',
            color: '#fff',
            marginLeft: 0,
            flexShrink: 0,
          }}
        />
      </ButtonComponent>
    </Grid>

    <Grid
      item
      lg={12}
      sm={12}
      xs={12}
      style={{ paddingTop: 10 }}
    >
      <Button2
        color="default"
        onClick={() => {
          window.location.href = '/clube-pai-eterno';
        }}
        style={{
          color: '#000',
          fontSize: '16px',
          backgroundColor: 'transparent',
        }}
      >
        Voltar
      </Button2>
    </Grid>

  </Form>
)}
{etapa === 2 && (
  <Form
    form={formEtapa2}
    size="middle"
    layout="vertical"
    scrollToFirstError
    onFinish={onSubmitFinal}
    labelAlign="left"
    requiredMark={false}
    style={{
      width: '100%',
    }}
    initialValues={{
      cep: '',
      descricao: '',
      uf: '',
      cidade: '',
      bairro: '',
      numero: '',
      complemento: '',
    }}
  >

    {/* ================= ENDEREÇAMENTO ================= */}

    <Grid container style={{ paddingTop: 40 }}>

      <Grid container className="section-title-grid">

        <div className="section-title-wrapper-endereco">

          <h2 className="section-title-text-endereco">

            <span className="section-star-endereco">

              <svg
                viewBox="0 0 100 100"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M50 6 C52 6, 54 8, 55 11 L64 34 L88 36 C92 36, 95 39, 96 42 C97 45, 96 48, 93 50 L75 65 L81 87 C82 91, 81 94, 78 96 C75 98, 72 97, 69 95 L50 82 L31 95 C28 97, 25 98, 22 96 C19 94, 18 91, 19 87 L25 65 L7 50 C4 48, 3 45, 4 42 C5 39, 8 36, 12 36 L36 34 L45 11 C46 8, 48 6, 50 6 Z"
                  fill="currentColor"
                />
              </svg>

            </span>

            Endereçamento

          </h2>

          <div className="section-line-endereco" />

          <span className="section-heart-endereco">

            <svg
              viewBox="0 0 100 90"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M50 82 C46 78, 12 57, 8 34 C5 18, 15 7, 29 5 C39 4, 47 9, 50 18 C53 9, 61 4, 71 5 C85 7, 95 18, 92 34 C88 57, 54 78, 50 82 Z"
                fill="currentColor"
              />
            </svg>

          </span>

        </div>

      </Grid>


      <Spin
        spinning={loadingCEP}
        tip="Buscando dados do CEP"
      >

        <Grid container>

          {/* CEP */}

          <Grid
            container
            justify="center"
            style={{ marginTop: 0 }}
          >

            <Grid
              item
              lg={12}
              sm={12}
              xs={12}
              className="campo-grid"
            >

              <Form.Item
                label={
                  <span>
                    CEP <span style={{ color: 'red' }}>*</span>
                  </span>
                }
                name="cep"
                rules={[
                  {
                    required: true,
                    message: '*Campo obrigatório',
                  },
                ]}
              >

                <MaskedInput
                  mask="11111-111"
                  onChange={(e: any) => {
                    debounceCEP(e.target.value);
                  }}
                />

              </Form.Item>

            </Grid>

          </Grid>


          {/* ENDEREÇO */}

          <Grid container justify="center">

            <Grid
              item
              lg={12}
              sm={12}
              xs={12}
              style={{
                paddingRight: 20,
                paddingLeft: 20,
              }}
            >

              <Form.Item
                label={
                  <span>
                    Endereço{' '}
                    <span style={{ color: 'red' }}>*</span>
                  </span>
                }
                name="descricao"
                rules={[
                  {
                    required: true,
                    message: '*Campo obrigatório',
                  },
                ]}
              >

                <Input placeholder="Digite o endereço" />

              </Form.Item>

            </Grid>

          </Grid>


          {/* UF + CIDADE */}

          <Grid container justify="center">

            <Grid
              item
              lg={6}
              sm={6}
              xs={12}
              className="campo-grid"
            >

              <Form.Item
                label={
                  <span>
                    Estado{' '}
                    <span style={{ color: 'red' }}>*</span>
                  </span>
                }
                name="uf"
                rules={[
                  {
                    required: true,
                    message: '*Campo obrigatório',
                  },
                  {
                    max: 2,
                    message: 'Somente sigla',
                  },
                ]}
              >

                <SelectAntd>

                  {suggestionsEstado.map(item => (
                    <SelectAntd.Option
                      key={item.label}
                      value={item.label}
                    >
                      {item.label}
                    </SelectAntd.Option>
                  ))}

                </SelectAntd>

              </Form.Item>

            </Grid>


            <Grid
              item
              lg={6}
              sm={6}
              xs={12}
              className="campo-grid"
            >

              <Form.Item
                label={
                  <span>
                    Cidade{' '}
                    <span style={{ color: 'red' }}>*</span>
                  </span>
                }
                name="cidade"
                rules={[
                  {
                    required: true,
                    message: '*Campo obrigatório',
                  },
                  {
                    pattern:
                      /^[A-Za-záàâãéèêíïóôõöúçñÁÀ ÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/,
                    message: 'Somente letras',
                  },
                ]}
              >

                <Input placeholder="Digite a cidade" />

              </Form.Item>

            </Grid>

          </Grid>


          {/* BAIRRO */}

          <Grid container justify="center">

            <Grid
              item
              lg={12}
              sm={12}
              xs={12}
              className="campo-grid"
            >

              <Form.Item
                label={
                  <span>
                    Bairro{' '}
                    <span style={{ color: 'red' }}>*</span>
                  </span>
                }
                name="bairro"
                rules={[
                  {
                    required: true,
                    message: '*Campo obrigatório',
                  },
                ]}
              >

                <Input placeholder="Digite o bairro" />

              </Form.Item>

            </Grid>

          </Grid>


          {/* NÚMERO + COMPLEMENTO */}

          <Grid container justify="center">

            <Grid
              item
              lg={6}
              sm={6}
              xs={12}
              className="campo-grid"
            >

              <Form.Item
                label={
                  <span>
                    Número{' '}
                    <span style={{ color: 'red' }}>*</span>
                  </span>
                }
                name="numero"
                rules={[
                  {
                    required: true,
                    message: 'Campo obrigatório',
                  },
                ]}
              >

                <Input placeholder="Digite o número" />

              </Form.Item>

            </Grid>


            <Grid
              item
              lg={6}
              sm={6}
              xs={12}
              className="campo-grid"
            >

              <Form.Item
                label={
                  <span>
                    Complemento (Opcional)
                  </span>
                }
                name="complemento"
              >

                <Input
                  placeholder="Ex.: Apto 101, Bloco C"
                />

              </Form.Item>

            </Grid>

          </Grid>

        </Grid>

      </Spin>

    </Grid>


    {/* ================= CADASTRAR ================= */}

    <Grid
      container
      item
      lg={12}
      sm={12}
      xs={12}
      justify="center"
      style={{ marginTop: 49 }}
    >

      <ButtonComponent
        color="secondary"
        loading={loadingCreatePessoaResponsavel}
        fullWidth
        type="submit"
        style={{
          width: '220px',
          maxWidth: '100%',
          minHeight: '45px',
          height: 'auto',
          minWidth: 0,
          borderRadius: '35px',
          background: '#76C65A',
          border: 'none',
          color: '#fff',
          fontSize: '18px',
          fontWeight: 'bold',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '10px',
          padding: '10px 20px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
          cursor: 'pointer',
          boxSizing: 'border-box',
        }}
      >

        <span>Cadastrar</span>

        <RocketLaunchIcon
          style={{
            fontSize: '24px',
            color: '#fff',
            marginLeft: 0,
            flexShrink: 0,
          }}
        />

      </ButtonComponent>

    </Grid>


    {/* ================= VOLTAR ================= */}

    <Grid
      item
      lg={12}
      sm={12}
      xs={12}
      style={{ paddingTop: 10 }}
    >

      <Button2
        color="default"
        onClick={() => {
          setEtapa(1);
        }}
        style={{
          color: '#000',
          fontSize: '16px',
          backgroundColor: 'transparent',
        }}
      >
        Voltar
      </Button2>

    </Grid>

  </Form>
)}

                </Grid>
              </Grid>

              <Grid
                container
                justify="center"
                className="seguranca-container"
              >
                {/*<LockOutlined className="seguranca-icon" />*/}

                <span className="seguranca-text">
                  Este é um ambiente seguro e suas informações estão seguras e protegidas.
                  Utilizamos criptografia de ponta a ponta!
                </span>
              </Grid>
            </div>
          </Grid>

          {/* --------------------------- RODAPÉ 1 ----------------------------- */}

          <Grid container item xs={12} style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0 12px', boxSizing: 'border-box', marginTop: 20 }} >
            <a href="https://wa.me/556235069800" target="_blank" rel="noopener noreferrer"
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexWrap: 'wrap',
                textAlign: 'center',
                gap: '5px',
                textDecoration: 'none',
                color: '#333',
              }}
            >
              <PhoneOutlined style={{ fontSize: '20px', color: '#999', }} />
              <span style={{ fontSize: '16px', fontWeight: 600, textAlign: 'center', }} >
                Central de Relacionamento:
              </span>
              <span style={{ fontSize: '16px', fontWeight: 600, textDecoration: 'underline', textAlign: 'center', }} >
                (62) 3506-9800
              </span>
            </a>
          </Grid>

          {/* --------------------------- RODAPÉ 2 ----------------------------- */}


          <Grid container item xs={12} style={{ width: '100%', margin: 0, padding: 0, overflow: 'hidden', }}>
            <img src={'https://crm-clickdobem.s3.sa-east-1.amazonaws.com/AFIPE/rodape.png'} alt="Rodapé"
              style={{
                width: '100%',
                height: 'auto',
                display: 'block',
                margin: 0,
                padding: 0,
              }}
            />
          </Grid>

          {/* --------------------------- RODAPÉ 3 ----------------------------- */}

          <Grid item lg={12} sm={12} xs={12} style={{paddingTop: 0}}>
            <Grid container alignItems="center" justify="center"
              style={{backgroundColor: '#6DBAE7', paddingTop: 10, paddingBottom: 10}}
            >
              <Grid container item lg={8} sm={8} xs={12} alignItems="center" justify="center" >
                <TitlePage style={{fontSize: 14, color:'#FFF'}}>Desenvolvido por  </TitlePage>
                <img src={'https://amex-arquivos.s3.sa-east-1.amazonaws.com/sociallis-logoPng.png'} style={{paddingLeft:10, width: 140 }} />
              </Grid>
            </Grid>
          </Grid>
        </div>

      </Grid>


    </>

  );
};

export default CadastroMirim;
